module.exports = __webpack_public_path__ + "img/map-big-dark2.3c93c610.png";